export default __webpack_public_path__ + "static/media/213.55ac4a12.jpg";